import { render } from "./BannerBlock.vue?vue&type=template&id=f2f3c242"
import script from "./BannerBlock.vue?vue&type=script&lang=js"
export * from "./BannerBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__